import { Color } from "@starrez/starryui";
import { DisabledOpacity, FontFamily, PixelUnit } from "@starrez/starryui/dist/Theme";
import styled from "styled-components";
import { IPopupOffset } from "./";

interface ISectionProps {
    theme: {
        MarginTopBottom?: string;
        Offset: string;
        Width: string;
        Height: string;
        BorderRadius: string;
        Fullscreen: boolean;
    };
}

interface IContainerProps {
    Offset?: IPopupOffset;
}

interface IFooterProps {
    FooterColor: string;
    BorderRadius: string;
}

interface IHeaderProps {
    HeaderColor: string;
    HeaderTextColor: string | undefined;
    BorderRadius: string;
}

interface ICloseButtonProps {
    ButtonColor: string | undefined;
    CloseButtonHoverColor: string | undefined;
}

export const Section = styled.section<ISectionProps>`
    background-color: white;
    display: flex;
    flex-direction: column;

    min-height: 20px;
    min-width: 20px;

    height: ${(props) => props.theme.Height === "auto" ? "auto" : `calc(${props.theme.Height} - ${props.theme.MarginTopBottom})`};
    margin-left: auto;
    margin-right: auto;
    margin-top: ${(props) => props.theme.MarginTopBottom};
    margin-bottom: ${(props) => props.theme.MarginTopBottom};
    width: ${(props) => props.theme.Width};

    border-radius: ${(props) => props.theme.BorderRadius};


    @media (min-width: ${(props) => props.theme.Width}) and (min-height: ${(props) => props.theme.Height}) {
        border: 1px solid ${Color.Grey.G20};
        border-radius: 5px;
        box-shadow: 0 5px 10px 0 rgba(0,0,0,0.07);
        overflow: auto;
    }

     @media (max-width: ${(props) => props.theme.Width}) {
        width: 100%;
        max-width: 95vw;
    }

    @media (max-height: ${(props) => props.theme.Height}) {
        height: 100%;
        max-height: 95vh;
    }
`;

export const ModalHeader = styled.header<IHeaderProps>`
    padding: ${PixelUnit(1)} ${PixelUnit(.5)} ${PixelUnit(1)} ${PixelUnit(3)};
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${Color.Grey.G20};
    min-height: 38px;
    background-color: ${(props) => props.HeaderColor};
    color: ${(props) => props.HeaderTextColor ? props.HeaderTextColor : Color.Grey.G80};
    border-radius: ${(props) => props.BorderRadius} ${(props) => props.BorderRadius} 0px 0px ;
`;

export const ModalDiv = styled.div<IContainerProps>`
    font-family: ${FontFamily};
    position: fixed;
    top: ${({ Offset }) => Offset?.Top || 0};
    left: ${({ Offset }) => Offset?.Left || 0};
    right: 0;
    bottom: 0;
    background-color: rgba(50,55,61,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 1000000;
`;

export const Footer = styled.footer<IFooterProps>`
    padding: ${PixelUnit(2)};
    border-radius:  0px 0px ${(props) => props.BorderRadius} ${(props) => props.BorderRadius};
`;

export const Article = styled.article`
    flex: 1 1 auto;
    overflow-y: auto;
    min-height: 0;
`;

export const CaptionDiv = styled.div`
    font-weight: bold;
    font-size: 16px !important;
    line-height: 130%;
    flex: 1 1 auto;
    margin-right: 80px;
`;

export const CloseButton = styled.button<ICloseButtonProps>`
    color: ${(props) => props.ButtonColor ? props.ButtonColor : Color.Grey.G70};
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    height: 40px;
    width: 40px;
    display: grid;
    align-items: center;
    justify-items: center;

    &[disabled] {
        opacity: ${DisabledOpacity};
        pointer-events: none;
    }

    &:hover {
        color: ${(props) => props.CloseButtonHoverColor ? props.CloseButtonHoverColor : Color.Grey.G80};
    }
`;
